import React from 'react';
import LogoSvg from 'static/images/adaya_logo_white.svg';
import SymbolSvg from 'static/images/adaya_logo.svg';

export default function Logo(props) {
    return (
        <div className="brand-logo">
            <img src={ (typeof props.symbol != 'undefined' ? SymbolSvg : LogoSvg) } />
        </div>
    );
}